import React from 'react';
import EstimateStatus from '../../enums/EstimateStatus';

interface EstimateStatusBadgeProps {
  status: EstimateStatus;
  label?: string;
  fontSize?: string;
}

export default function EstimateStatusBadge({
  status,
  label = undefined,
  fontSize = '0.75rem',
}: EstimateStatusBadgeProps) {
  const badgeParams: any = {
    [EstimateStatus.Draft]: {
      title: 'Rascunho',
      class: 'badge-outline',
    },
    [EstimateStatus.Wip]: {
      title: 'Em Andamento',
      class: 'bg-primary',
    },
    [EstimateStatus.Completed]: {
      title: 'Concluído',
      class: 'badge-outline success',
    },
    [EstimateStatus.Canceled]: {
      title: 'Cancelado',
      class: 'bg-dark',
    },
  };

  return (
    <span
      className={`badge ${badgeParams[status].class} text-uppercase`}
      style={{ fontSize }}
      title={label}
    >
      {badgeParams[status].title}
    </span>
  );
}
